import styled from '@emotion/styled';
import TagV2 from '@zola/zola-ui/src/components/Tag/TagV2';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';

export const StyledTagV2 = styled(TagV2)`
  margin-bottom: ${SPACING.XS};
`;
